UsersIndex

<template>
	<div id="wrapper">
		<SidebarView :users="true" :user-visible="true" :audit="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div>
								<div class="card card-shape home-box">
									<div class="card-header border-bottom-0 d-flex justify-content-between align-items-center">
										<h6 class="m-0 fw-bold text-green">
											Audit Trail
										</h6>

										<div class="d-flex">
											<div class="me-2">
												<b-link @click="printAuditList" class="fw-semibold ms-2 akkurate-green">
													<font-awesome-icon :icon="['fas', 'print']" /></b-link>
											</div>
											<div>
												<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
													<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
											</div>
										</div>
									</div>
									<!-- <div class="card-body">
										<div></div>
									</div> -->

									<div class="card-body default_bg" style="
											border-bottom: 1px solid
												rgb(1, 134, 115);
										">
										<div class="home-box border border-success py-1 bg-white">
											<div class="card-body">
												<!-- <member-filter :form="form" :filterTable="filterTable"></member-filter> -->
												<form @submit.prevent="
													filterTable()
													">
													<div class="row">
														<div class="col-md-6">
															<label class="akkurate-dark small d-none d-lg-block" for="search_term">Search
																Term</label>
															<b-form-group id="search_term" label-for="search_term">
																<b-form-input class="mt-2 field-container fields" type="text" v-model="form.search_term
																	" placeholder="Search by firstname, lastname, phone number, email, staff ID">
																</b-form-input>
															</b-form-group>
														</div>

														<div class="col-md-4 mb-2">
															<label class="akkurate-dark small" for="trans_source">Users</label>
															<multiselect class="mt-1 field-container" v-model="form.users
																" :options="users_options
																	" placeholder="Select User" selectLabel="" :custom-label="fullName
																		" :close-on-select="false
																			" :clear-on-select="false
																				" :multiple="true" deselectLabel="" :limit-text="limitText
																					" :limit="1" track-by="id">
															</multiselect>
															<!-- <multiselect
																class="field-container mt-1"
																v-model="
																	form.users
																"
																:options="
																	users_options
																"
																:multiple="true"
																placeholder="Select Ro"
																label="name"
																:custom-label="
																	getUserLabel
																"
																selectLabel=""
																deselectLabel="">
																<template
																	slot="selection">
																	<span
																		class="multiselect__single"
																		v-if="
																			form
																				.users
																				.length
																		"
																		>{{
																			form
																				.users
																				.length
																		}}
																		options
																		selected</span
																	>
																</template>
</multiselect> -->
														</div>
														<div class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mb-2 mt-auto">
															<b-button type="submit" class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center"><i class="fas fa-search"></i><span class="d-none d-lg-block ms-2">Search</span></b-button>
															<b-button size="sm" v-b-modal.modal-member title="show more filters" class="ms-2">
																<i class="fas fa-bars akkurate-small"></i>
															</b-button>
														</div>
													</div>
												</form>
											</div>
										</div>
									</div>
									<div class="card-body pt-0">
										<div class="table_text_size">
											<div class="" ref="auditListContent">
												<b-table striped bordered responsive id="users-table" :busy.sync="isBusy" :items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
													<template #table-busy>
														<div class="text-center text-danger my-2">
															<b-spinner class="align-middle"></b-spinner>
															<strong>Loading...</strong>
														</div>
													</template>
													<template #cell(index)="data">
														{{ data.index + 1 }}
													</template>
													<template #cell(user)="data">
														<div class="text-center small">
															{{
																data.item.causer
																	?.first_name
															}}
															{{
																data.item.causer
																	?.surname
															}}
														</div>
													</template>
													<template #cell(description)="data">
														{{ data.item.description +
															(data.item.subject?.loan_number && data.item.subject?.principal_amount ?
																' - ' + data.item.subject.loan_number + ', Amount: GHS' + data.item.subject.principal_amount + ', '
																+ (data.item.subject?.loan_type || "") :
																data.item?.causer && data.item?.causer.trans_amount ? ' - Amount: GHS ' + data.item.causer.trans_amount : "") }}
													</template>
													<template #cell(created_at)="data">
														{{ formatDateAndTime(data.item.created_at) }}
													</template>
													<template #cell(actions)="data" class="actions">
														<span class="d-flex actions">
															<audit-view :data="data.item" />
															<a title="Print" class="btn btn-sm border-0 akkurate-green-btn text-white custom-pointer" @click="printAuditLog(data.item)">
																<span class="akkurate-small"><font-awesome-icon :icon="['fas', 'print']" /></span>
															</a>
														</span>

													</template>
												</b-table>
											</div>
											<div class="d-flex justify-content-between">
												<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" aria-controls="users-table"></b-pagination>
												<div class="col text-end mt-1">
													<div>
														{{ currentPage }} -
														{{ perPage }} of
														{{ totalRecords }}
													</div>
													<b-form-group label="Per Page" label-size="sm" class="mb-0">
														<b-form-select @change="
															selectPerPage
														" id="per-page-select" v-model="perPage" :options="per_page_options
															" size="sm"></b-form-select>
													</b-form-group>
												</div>
											</div>
										</div>


										<b-modal size="xl" id="bv-modal-example">
											<template #modal-title>
												<h6 class="akkurate-green fw-bold">
													Audit Log
												</h6>
											</template>
											<print-audit :data="auditData" :institution="institution" ref="printAudit"></print-audit>
											<template #modal-footer>
												<div class="w-100">
													<!-- Emulate built in modal footer ok and cancel button actions -->
													<b-button @click="handleGeneratePDF" type="button" class="akkurate-green-btn btn-size download-btn ms-2 float-right"><span class="small"><font-awesome-icon :icon="[
														'fas',
														'print',
													]" />
															Print</span></b-button>
													<b-button @click="handleExportToPDF" class="akkurate-green-btn btn-size download-btn float-right"><span class="small"><font-awesome-icon :icon="[
														'fas',
														'save',
													]" />
															Download</span></b-button>
												</div>
											</template>
										</b-modal>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- end row  -->

					<b-modal size="lg" id="modal-member" @ok="handleOk">
						<template #modal-title>
							<h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
						</template>
						<audit-filter :form="form" :filterTable="filterTable">
						</audit-filter>
						<template #modal-footer="{ ok }">
							<div class="w-100">
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button @click="$bvModal.hide('modal-member')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
									</span></b-button>
								<b-button @click="ok()" type="submit" :disabled="isSearching" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'search']" />Search</span></b-button>
							</div>
						</template>
					</b-modal>
				</div>
			</div>
			<Footer></Footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import ExcelJS from "exceljs";
import AuditView from "../view/AuditView.vue";
import AuditFilter from "../forms/AuditFilter.vue";
import Multiselect from "vue-multiselect";
import defaultLogo from '@/assets/img/default_logo.png'
import PrintAudit from "../report/printAudit.vue";
import html2pdf from "html2pdf.js";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		AuditView,
		AuditFilter,
		Multiselect,
		PrintAudit,
		ChatBot,
	},
	mounted() {
		let token = localStorage.getItem("token");
		if (!token) {
			this.$router.push({ path: "/login" });
		}
		this.getAccountDropdown();
		this.getInstitution();
		this.loadItems();
	},
	computed: {
		getUsers() {
			if (this.form.users.length > 0) {
				const result = this.form.users.map((index) => {
					return (
						index.first_name +
						" " +
						index.surname +
						" - " +
						index.id
					);
				});
				// console.log("here");
				return result.join(" | "); // Join array elements with ", "
			} else {
				return "";
			}
		},
	},
	data() {
		return {
			isSearching: false,
			totalRecords: 0,
			searchFilter: "",
			isLoading: true,
			isBusy: true,
			currentPage: 1,
			perPage: 10,
			users_options: [],
			auditData: {},
			institution: {},
			per_page_options: ["10", "20", "50", "100"],
			per_page_selected: "10",
			form: {
				search_term: "",
				from_date: "",
				to_date: "",
				branch: "",
				start_date: "",
				end_date: "",
				users: [],
			},
			fields: [
				{
					label: "#",
					key: "index",
				},
				{
					label: "User",
					key: "user",
				},
				{
					label: "Activity",
					key: "log_name",
				},
				{
					label: "Description",
					key: "description",
				},
				{
					label: "Recorded Date",
					key: "created_at",
				},
				{
					label: "Actions",
					key: "actions",
				},
			],
			rows: [],
		};
	},
	methods: {
		async getAccountDropdown() {
			this.$Progress.start();
			this.isBusy = true;
			await ApiService.get("/accounts/create/dropdown")
				.then((response) => {
					// console.log(response);
					// this.form.branch_option = response?.data?.branches;
					this.users_options = response?.data?.users;
					this.isBusy = false;
					this.$Progress.finish();
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		fullName({ first_name, middle_name, surname, id, branch }) {
			let name = "";
			if (first_name) {
				name = name + first_name;
			}

			if (middle_name) {
				name = name + " " + middle_name;
			}

			if (surname) {
				name = name + " " + surname;
			}

			//   if(code)
			//   {
			//     name = name + ` (${code})`;
			//   }

			return `${name} - ${id} ${branch ? " - " + branch.name : ""}`;
		},
		limitText(count) {
			return `and ${count} other user(s)`;
		},
		handleOk(bvModalEvent) {
			// Prevent modal from closing
			// bvModalEvent.preventDefault();
			// Trigger submit handler
			this.filterTable();
		},
		filterTable() {
			this.loadItems();
		},
		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},
		rowClass() {
			return "custom-row-height";
		},
		getUserLabel({ id, first_name, surname }) {
			return `${id} ${first_name} ${surname}`;
		},

		// load items is what brings back the rows from server
		async loadItems() {
			this.isLoading = true;
			this.isBusy = true;
			this.$Progress.start(); // Start the progress bar

			try {
				const response = await ApiService.post("users/activity-logs", {
					page: this.currentPage,
					per_page: this.perPage,
					filter: this.form.search_term,
					branch_id: this.form.branch?.id,
					start_date: this.form.start_date,
					end_date: this.form.end_date,
					users: this.form.users.map((user) => user.id),
				});

				this.totalRecords = response.data.total;
				this.rows = response.data.data;
				// console.log(response);
			} catch (error) {
				console.error("Error loading items:", error);
				// Optionally: show a toast or notification
			} finally {
				this.isBusy = false;
				this.isLoading = false;
				this.$Progress.finish();
			}
		},

		confirmDeleteUser(user) {
			swal.fire({
				title: "Disable User",
				text: `Are you sure you want to disable ${user.username}?`,
				icon: "warning",
				showCancelButton: false,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Ok",
				allowOutsideClick: false,
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-danger-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
				},
			}).then((result) => {
				if (result.value) {
					//   window.location.reload();
				}
			});
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`I${institutionDetailsRow}`).value = institutionName;
				ws.getCell(`I${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

				ws.getCell(`I${institutionDetailsRow + 1}`).value = institutionAddress;
				ws.getCell(`I${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

				ws.getCell(`I${institutionDetailsRow + 2}`).value = institutionMotto;
				ws.getCell(`I${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 3}`).value = institutionPhone;
				ws.getCell(`I${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 4}`).value = institutionEmail;
				ws.getCell(`I${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn('J').width = 50;  // Adjust the width of column D (if necessary)

				// Define header row
				const mainHead = ["AUDIT TRAIL"];
				const header = [
					"#",
					"User",
					"Activity",
					"Description",
					"Recorded Date"
				];



				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = mainHead;
				headerRow.font = { bold: true };
				headerRow.commit();

				let currentRow = startingRow + 1; // Start from the next row after the header

				// add a row with the value of AUDIT TRAIL with bold font and larger font size that spans 5 columns with center alignment
				ws.getCell(`A${startingRow}`).value = "AUDIT TRAIL";
				ws.mergeCells(startingRow, 1, startingRow, 5); // Merge cells for the main header
				ws.getCell(`A${startingRow}`).font = { bold: true, size: 20 }; // Set font size for the main header
				ws.getCell(`A${startingRow}`).alignment = { horizontal: "center" }; // Center align the main header

				headerRow = ws.getRow(currentRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				currentRow++;

				// Process each item
				this.rows.forEach((item, i) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						i + 1, // Index starts from 1
						item.causer ? item.causer?.first_name + (item.causer?.middle_name ? " " + item.causer.middle_name : " ") + item.causer?.surname + ' - ' + item.causer?.id : '',
						item.log_name,
						item.description + (item.subject?.loan_number && item.subject?.principal_amount ? ' - ' + item.subject.loan_number + ', Amount: GHS' + item.subject.principal_amount + ', ' + (item.subject?.loan_type || "") : item?.causer && item?.causer?.id ? ' - ' + item.causer.id : ''),
						item.updated_at ? this.formatDateAndTime(item.updated_at) : ''
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "journal_export.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		printAuditLog(row) {
			this.auditData = row;
			this.$nextTick(() => {
				this.$bvModal.show("bv-modal-example");
			});
		},
		handleGeneratePDF() {
			this.$refs.printAudit.generatePDF();
		},
		handleExportToPDF() {
			this.$refs.printAudit.exportToPDF();
		},
		async getInstitution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		printAuditList() {
			const originalAuditContent = this.$refs.auditListContent; // Reference to the HTML content you want to convert

			const content = document.createElement('div')
			content.classList.add('row')
			content.classList.add('d-flex')
			content.classList.add('flex-column')
			content.style.marginLeft = "8px"
			content.style.marginTop = "10px"
			content.style.marginBottom = "10px"
			content.style.width = "210mm"

			if (!originalAuditContent)
				return;
			const auditContent = originalAuditContent.cloneNode(true)
			// turn Actions column of the table to invisible

			auditContent.style.width = "96%"
			auditContent.classList.add('akkurate-extra-small')
			auditContent.classList.add('printing')

			const head = document.createElement('div')
			const body = document.createElement('div')
			head.classList.add("row");
			head.classList.add("mt-0");
			head.innerHTML = `
				<div
					class="col-md-4 col-4 d-flex align-items-center mb-2 flex-column bd-highlight">
					<!-- First Image -->
					<img
						class="img-fluid img-visibility statement-logo"
						src="${defaultLogo}"
						style="width: 120px !important" />
					<div class="mt-0 akkurate-green fw-bold p-0 bd-highlight">
						AUDIT TRAIL LIST
					</div>
				</div>
				<div
					class="d-flex align-items-end flex-column bd-highlight col-md-8 col-8 text-end">
					<p class="fw-bold text-uppercase mb-0">
						${this.institution?.name}
					</p>
					<p class="fw-bold mt-0" style="margin-bottom: 0.2rem">
						${this.institution?.motto}
					</p>
					<p class="mb-0 akkurate-small">${this.institution?.postal}</p>
					<p class="mb-0 akkurate-small">
						${this.institution?.telephone}
					</p>
					<p class="akkurate-small mb-0">${this.institution?.email}</p>
					<p
						class="fw-bold text-end mt-auto mb-1 p-0 bd-highlight text-uppercase">
						${new Intl.DateTimeFormat("en-GB", {
				day: "numeric",
				month: "long",
				year: "numeric",
			}).format(Date.now())
				}
					</p>
				</div>

				<hr class="ms-2 mt-0 akkurate-dark mx-auto"  style="width: 98.5%;" />

					
						
					</div>
				`

			content.appendChild(head)
			content.appendChild(auditContent)

			// console.log("here");
			const pdfOptions = {
				margin: 0, // top, right, bottom, left margins,
				filename: "schedule.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: {
					unit: "in",
					format: "a4",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}

					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						// URL.revokeObjectURL(url);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
	},
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.printing .actions {
	display: none !important;
}
</style>
